import React from 'react';
import dayjs from 'dayjs';
import type { EndUseRecord } from '../services/api';
import { resolveUploadAssetUrl } from '../utils/resolveUploadAssetUrl';

interface EndUseRecordViewProps {
  record: EndUseRecord;
  bookerName?: string;
}

const EndUseRecordView: React.FC<EndUseRecordViewProps> = ({ record, bookerName }) => {
  const groups = record.photoGroups || [];

  return (
    <div className="end-use-record-view">
      {bookerName && (
        <p className="text-muted small mb-2">
          预约人：{bookerName}
          {record.submittedAt && (
            <> · 提交于 {dayjs(record.submittedAt).format('YYYY-MM-DD HH:mm')}</>
          )}
        </p>
      )}
      {!bookerName && record.submittedAt && (
        <p className="text-muted small mb-2">
          提交于 {dayjs(record.submittedAt).format('YYYY-MM-DD HH:mm')}
        </p>
      )}
      {record.notes?.trim() && (
        <div className="mb-3">
          <strong className="small d-block mb-1">文字说明</strong>
          <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
            {record.notes}
          </p>
        </div>
      )}
      {groups.map((group) => (
        <div key={group.groupKey || group.label} className="mb-3">
          <strong className="small d-block mb-2">{group.label || '照片'}</strong>
          {(group.urls || []).length === 0 ? (
            <span className="text-muted small">未上传</span>
          ) : (
            <div className="d-flex flex-wrap gap-2">
              {(group.urls || []).map((url, idx) => (
                <a
                  key={`${url}-${idx}`}
                  href={resolveUploadAssetUrl(url) || url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={resolveUploadAssetUrl(url) || url}
                    alt={group.label}
                    style={{
                      width: 96,
                      height: 96,
                      objectFit: 'cover',
                      borderRadius: 8,
                      border: '1px solid #dee2e6'
                    }}
                  />
                </a>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default EndUseRecordView;
